"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
exports.__esModule = true;
exports.MAX_NUMBER_OF_TOKEN_FETCH_RETRIES = 3;
// GCC High gov cloud URLs
exports.GCCHIGH_TROUTER_SERVICE_URL = "https://go.trouter.gov.teams.microsoft.us/v4/a";
exports.GCCHIGH_REGISTRAR_SERVICE_URL = "https://registrar.gov.teams.microsoft.us/V3/registrations";
// GCC gov cloud URLs
exports.GCC_TROUTER_SERVICE_URL = "https://go.trouter.gcc.teams.microsoft.com/v4/a";
// DoD gov cloud URLs
exports.DOD_TROUTER_SERVICE_URL = "https://go.trouter.dod.teams.microsoft.us/v4/a";
exports.DOD_REGISTRAR_SERVICE_URL = "https://registrar.dod.teams.microsoft.us/V3/registrations";
// Int URLs
exports.INT_TROUTER_SERVICE_URL = "https://go.trouter-int.skype.net/v4/a";
exports.INT_REGISTRAR_SERVICE_URL = "https://edge.skype.net/registrar/testenv/v3/registrations";
// EUDB URLs
exports.EUDB_TROUTER_SERVICE_URL = "https://go-eu.trouter.teams.microsoft.com/v4/a";
// Public URLs
exports.PUBLIC_TROUTER_SERVICE_URL = "https://go.trouter.teams.microsoft.com/v4/a";
exports.PUBLIC_REGISTRAR_SERVICE_URL = "https://teams.microsoft.com/registrar/prod/v3/registrations";
// Gov cloud types
var CloudType;
(function (CloudType) {
    CloudType["Public"] = "Public";
    CloudType["GccHigh"] = "GCC High";
    CloudType["Dod"] = "DoD";
})(CloudType = exports.CloudType || (exports.CloudType = {}));
var CloudPrefix;
(function (CloudPrefix) {
    CloudPrefix["OrgId"] = "orgid";
    CloudPrefix["Acs"] = "acs";
    CloudPrefix["Spool"] = "spool";
    CloudPrefix["GccHigh"] = "gcch";
    CloudPrefix["GccHighAcs"] = "gcch-acs";
    CloudPrefix["Dod"] = "dod";
    CloudPrefix["DodAcs"] = "dod-acs";
})(CloudPrefix = exports.CloudPrefix || (exports.CloudPrefix = {}));
exports.EudbCountries = ["europe", "france", "germany", "norway", "switzerland", "sweden"];
